export function getPagination(paginationParams: PaginationParams, data: any[]) {

    const pagination: any[][] = [];

    let count = 0;
    for (let i = 0; i < data.length; i += paginationParams.pageMaxSize) {
        const nextIndex = Math.min(paginationParams.pageMaxSize * (count + 1), data.length);
        const currentList = data.slice(i, nextIndex);
        pagination[count] = currentList;
        count++;
    }

    return pagination;
}

export class PaginationParams {
    pageMaxSize: number;
    currentPage: number;
    currentIndex: number;

    constructor(pageMaxSize: number, currentPage: number, currentIndex: number) {
        this.pageMaxSize = pageMaxSize;
        this.currentPage = currentPage;
        this.currentIndex = currentIndex;
    }
}